import { usePermissions } from "@/context/PermissionsContext";
import { BOUNCER_PERMISSIONS } from "@/constants/bouncerPermissions";
import { useWalletFlag } from "./useWalletFlag";

/**
 * Whether the current user may see wallet surfaces.
 *
 * Two independent gates, both required:
 * - the `vip_wallet` feature flag — the wallet's own release toggle, separate
 *   from `vip_payments` so Payments can ship first;
 * - the `VENDOR_WALLET_VIEW` permission — who may see a wallet at all.
 *
 * Every wallet entry point calls this rather than repeating the AND, so the two
 * gates cannot drift apart when one surface is edited.
 *
 * `enabled: false` skips the flag request and returns false — for app-wide
 * callers such as the header, which renders on every module but only shows the
 * wallet on invoice management.
 */
export function useWalletAccess(options?: { enabled?: boolean }): boolean {
  const isWalletEnabled = useWalletFlag(options);
  const { hasPermission } = usePermissions();
  return isWalletEnabled && hasPermission(BOUNCER_PERMISSIONS.VENDOR_WALLET_VIEW);
}
